import React from 'react';
import clsx from 'clsx';

import styles from './Spinner.module.scss';

type LoadingProps = { isCentered?: boolean; width?: number; height?: number };

const Spinner = ({ isCentered, width = 40, height = 40 }: LoadingProps) => (
  <div className={clsx(styles.loader, { [styles.centered]: isCentered })}>
    <div className={styles.loader__spinner} style={{ width: `${width}px`, height: `${height}px` }} />
  </div>
);

export { Spinner };
